import { TranslationPath } from '../i18n';

export { CONFIDENTIALITIES, CONTRIBUTORS_ROLES, DRIVE_ROLES, FILE_ROLES, GOOGLE_ROLES, INPUT_TYPES, LANGUAGES };

const DRIVE_ROLES = createConstantLabelsMap<Constants.Api.PermissionDriveRole>({
  ORGANIZERS: 'common.constants.permissionTypes.driveRole.ORGANIZERS',
  FILE_ORGANIZERS: 'common.constants.permissionTypes.driveRole.FILE_ORGANIZERS',
  WRITERS: 'common.constants.permissionTypes.driveRole.WRITERS',
  COMMENTERS: 'common.constants.permissionTypes.driveRole.COMMENTERS',
  READERS: 'common.constants.permissionTypes.driveRole.READERS',
});

const FILE_ROLES = createConstantLabelsMap<Constants.Api.PermissionFileRole>({
  WRITERS: 'common.constants.permissionTypes.fileRole.WRITERS',
  COMMENTERS: 'common.constants.permissionTypes.fileRole.COMMENTERS',
  READERS: 'common.constants.permissionTypes.fileRole.READERS',
});

const CONTRIBUTORS_ROLES = createConstantLabelsMap<Constants.Api.PermissionContributorRole>({
  CONTRIBUTORS: 'common.constants.permissionTypes.contributorRole.CONTRIBUTORS',
  CREATOR: 'common.constants.permissionTypes.contributorRole.CREATOR',
});

const INPUT_TYPES = createConstantLabelsMap<Constants.Api.UserDefinedInputTypes | Constants.Api.InputTypes>({
  approvers: 'common.constants.inputTypes.approvers',
  boolean: 'common.constants.inputTypes.boolean',
  confidentiality: 'common.constants.inputTypes.confidentiality',
  contributor: 'common.constants.inputTypes.contributor',
  contributors: 'common.constants.inputTypes.contributors',
  creator: 'common.constants.inputTypes.creator',
  custom: 'common.constants.inputTypes.custom',
  date: 'common.constants.inputTypes.date',
  distribution: 'common.constants.inputTypes.distribution',
  distributors: 'common.constants.inputTypes.distributors',
  drive: 'common.constants.inputTypes.drive',
  email: 'common.constants.inputTypes.email',
  file_confidentiality: 'common.constants.inputTypes.file_confidentiality',
  float: 'common.constants.inputTypes.float',
  folder: 'common.constants.inputTypes.folder',
  integer: 'common.constants.inputTypes.integer',
  label: 'common.constants.inputTypes.label',
  language: 'common.constants.inputTypes.language',
  needs_update: 'common.constants.inputTypes.needs_update',
  permission: 'common.constants.inputTypes.permission',
  property_options_list: 'common.constants.inputTypes.property_options_list',
  property_person: 'common.constants.inputTypes.property_person',
  requesters: 'common.constants.inputTypes.requesters',
  status: 'common.constants.inputTypes.status',
  string: 'common.constants.inputTypes.string',
  tag: 'common.constants.inputTypes.tag',
  user_format_string: 'common.constants.inputTypes.user_format_string',
  verification_process_status: 'common.constants.inputTypes.verification_process_status',
});

const CONFIDENTIALITIES = createConstantLabelsMap<Constants.Api.Confidentiality>({
  confidential: 'common.constants.confidentialities.confidential',
  internal: 'common.constants.confidentialities.internal',
  public: 'common.constants.confidentialities.public',
  secret: 'common.constants.confidentialities.secret',
});

const LANGUAGES = createConstantLabelsMap<Constants.Api.SupportedLanguages>({
  English: 'common.constants.languages.English',
  French: 'common.constants.languages.French',
  Spanish: 'common.constants.languages.Spanish',
  Italian: 'common.constants.languages.Italian',
  Croatian: 'common.constants.languages.Croatian',
  Czech: 'common.constants.languages.Czech',
  Danish: 'common.constants.languages.Danish',
  Dutch: 'common.constants.languages.Dutch',
  Finnish: 'common.constants.languages.Finnish',
  German: 'common.constants.languages.German',
  Greek: 'common.constants.languages.Greek',
  Hungarian: 'common.constants.languages.Hungarian',
  Japanese: 'common.constants.languages.Japanese',
  Lithuanian: 'common.constants.languages.Lithuanian',
  Latvian: 'common.constants.languages.Latvian',
  Norwegian: 'common.constants.languages.Norwegian',
  Polish: 'common.constants.languages.Polish',
  Portuguese: 'common.constants.languages.Portuguese',
  Romanian: 'common.constants.languages.Romanian',
  Russian: 'common.constants.languages.Russian',
  Slovak: 'common.constants.languages.Slovak',
  Slovenian: 'common.constants.languages.Slovenian',
  Swedish: 'common.constants.languages.Swedish',
});

const GOOGLE_ROLES = createConstantLabelsMap<
  Exclude<Constants.Google.OAuthRoles, 'internal_api' | 'overlayer_super_user'>
>({
  domain_operator: 'common.constants.googleRoles.domain_operator',
  google_domain_admin: 'common.constants.googleRoles.google_domain_admin',
  google_domain_user: 'common.constants.googleRoles.google_domain_user',
  google_domain_dedicated_user: 'common.constants.googleRoles.google_domain_dedicated_user',
});

function createConstantLabelsMap<K extends string>(record: Record<K, AllowedPaths>) {
  const entries = Object.entries<AllowedPaths>(record) as [K, AllowedPaths][];
  return Object.assign(
    entries.map(([value, label]) => ({ label, value })),
    { entriesMap: new Map<K, AllowedPaths>(entries) },
  );
}

type AllowedPaths = Extract<TranslationPath<'common'>, `common.constants.${string}`>;
